/**
 * Shared filter options for desktop and mobile filter panels
 */
import React from 'react';
import { IconWSBacklog, IconWSInProgress, IconWSClosed, IconPromote } from 'components/Icons';
import type { WorkState } from '../../../RequestCard';
import type { DueDatePreset, RequestTypeFilter } from './FilterModalContent';

/** Work state filter options with icons */
export const workStateOptions: { value: WorkState; label: string; icon: React.ReactNode }[] = [
  { value: 'todo', label: 'Not Started', icon: <IconWSBacklog /> },
  { value: 'in-progress', label: 'In Progress', icon: <IconWSInProgress /> },
  { value: 'blocked', label: 'Blocker', icon: <IconPromote /> },
  { value: 'closed', label: 'Completed', icon: <IconWSClosed /> },
];

/** Due date preset options */
export const dueDateOptions: { value: DueDatePreset; label: string }[] = [
  { value: 'overdue', label: 'Overdue' },
  { value: 'today', label: 'Due Today' },
  { value: 'this-week', label: 'This Week' },
  { value: 'this-month', label: 'This Month' },
  { value: 'no-due-date', label: 'No Due Date' },
];

/** Request type filter options */
export const requestTypeOptions: { value: RequestTypeFilter; label: string }[] = [
  { value: 'email', label: 'Email' },
  { value: 'transaction', label: 'Transaction' },
  { value: 'flagged-cell', label: 'Flagged Cell' },
  { value: 'custom-request', label: 'Custom Request' },
];
